<template>
  <div>
    <b-button v-b-modal.modal-prevent-closing2>Добавити мінус</b-button>
    <b-modal
      centered
      id="modal-prevent-closing2"
      ref="modal"
      title="Мінус"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Сума"
          label-for="name-input"
          invalid-feedback="Введіть суму оплати!"
          :state="modalState"
        >
          <b-form-input
            id="name-input"
            @blur="$v.sub.amount.$touch()"
            v-model="sub.amount"
            :state="modalState"
            type="number"
            step="100"
            required
            :class="{
              'is-invalid': $v.sub.amount.$error && $v.sub.amount.$dirty,
            }"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Причина"
          label-for="name-input"
          invalid-feedback="Введіть суму оплати!"
          :state="modalState"
        >
          <b-form-select
            :options="options"
            id="name-input"
            v-model="sub.source"
            :state="modalState"
            @blur="$v.source.$touch()"
            required
            :class="{
              'is-invalid': $v.sub.source.$error && $v.sub.source.$dirty,
            }"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          label="Записка"
          label-for="name-input"
          invalid-feedback="Записка має бути не меньш ніж 4 символи!"
          :state="modalState"
        >
          <b-form-input
            id="name-input"
            v-model="sub.log"
            :state="modalState"
            required
            @blur="$v.sub.log.$touch()"
            :class="{ 'is-invalid': $v.sub.log.$error && $v.sub.log.$dirty }"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";

var axios = require("axios");
export default {
  name: "MoneySub",
  props: {
    club_id: Number,
  },
  data: function () {
    return {
      sub: {
        amount: null,
        source: null,
        log: null,
      },
      modalState: null,
      options: [
        { value: 1, text: "Затрати комплекс" },
        { value: 2, text: "Затрати фітнес клуб" },
        { value: 14, text: "Аванс" },
        { value: 3, text: "Хімія" },
        { value: 4, text: "Кавав" },
        { value: 5, text: "Стакани" },
        { value: 6, text: "Чай" },
        { value: 15, text: "Вода" },
        { value: 7, text: "Батони" },
        { value: 8, text: "Спортпіт" },
        { value: 9, text: "Канцелярія" },
        { value: 10, text: "Сувенірна продукція" },
        { value: 11, text: "Тренажери" },
        { value: 12, text: "Комуналка" },
        { value: 13, text: "Інше" },
      ],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  validations: {
    sub: {
      amount: {
        required,
      },
      source: {
        required,
      },
      log: {
        required,
        minLength: minLength(4),
      },
    },
  },
  methods: {
    ...mapActions(["logOutUser"]),
    resetModal() {
      this.sub = {
        amount: null,
        log: null,
        source: null,
      };
      this.$v.sub.$reset();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
        return;
      }
      await axios
        .post(`${process.env.VUE_APP_API}/money/outcome`, this.sub, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          if (error.response.status !== 401) {
            console.log(error.response.data);
          } else {
            this.logOutUser();
          }
        });
      this.$emit("refresh-stuff");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing2");
      });
    },
  },
};
</script>

<style scoped></style>
